import { environment } from '../../../../environments/environment';

export const url = {
    consulta: {
        municipiosUf:{
            get_uf:'https://servicodados.ibge.gov.br/api/v1/localidades/estados',
            get_municipios: 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/'
        }
    }
}